import type { ParsedUrlQuery } from 'querystring'
import type { GetServerSideProps } from 'next'

import { getWalk } from 'lib/content'
import sanitizeKalturaUrl from 'lib/sanitizeKalturaUrl'
import WalkLanding, {
  WalkLandingProps,
} from 'components/presentation/WalkLanding'

const PageComponent = WalkLanding

interface PageParams extends ParsedUrlQuery {
  walk: string
}

export const getServerSideProps: GetServerSideProps<
  WalkLandingProps,
  PageParams
> = async ({ params, locale = 'en' }) => {
  if (!params) {
    throw new Error('No parameters passed to getServerSideProps')
  }

  const walk = await getWalk(params.walk, locale)

  if (walk == null) {
    return { notFound: true }
  }

  const stops = walk.stops.map(({ image_url, name, lat, lng, slug }) => ({
    imageUrl: sanitizeKalturaUrl(image_url, 200),
    name: name[locale] ?? '',
    lat,
    lng,
    slug,
  }))

  return {
    props: {
      walkName: walk.name[locale] ?? '',
      walkDescription: walk.description[locale] ?? '',
      cityName: walk.city[locale] ?? '',
      organizationName: walk.organization[locale] ?? '',
      ageRange: walk.age_range[locale] ?? '',
      distance: walk.distance[locale] ?? '',
      duration: walk.duration[locale] ?? '',
      imageUrl: sanitizeKalturaUrl(walk.image_url),
      stops,
      walkSlug: params.walk,
    },
  }
}

export default PageComponent
